import { Arrows } from '@ad-lucy/components/nav/NavigationArrow/types';
import {
  CREATIVE_TYPE,
  type CreativesConfig,
  defaultCreativesConfig,
} from '@ad-lucy/config/creatives';
import { GlobalPayout } from '@ad-lucy/utils/types';
import type { componentNames } from './componentNames';

type BpCreativesConfigComponentKeys = (typeof componentNames)[number];

export const bpConfig: CreativesConfig<BpCreativesConfigComponentKeys> = {
  ...defaultCreativesConfig,
  id: CREATIVE_TYPE.BP,
  name: 'Branded Player',
  navigation: {
    ...defaultCreativesConfig.navigation,
    arrows: Arrows.ROUNDED,
    defaults: {
      ...defaultCreativesConfig.navigation.defaults,
      enableOverlay: false,
    },
    trackInitialViewOnlyIfInActiveTab: true,
  },
  settings: {
    ...defaultCreativesConfig.settings,
    hideFooter: true,
    headerHeight: {
      desktop: '110',
      hpa: '80',
      mobile: '60',
    },
    headerEnableHeightSettingsDifferentViewports: true,
    forceGlobalPayout: GlobalPayout.NO_PAYOUT_ON_HOVER,
  },
  breakpoints: {
    ...defaultCreativesConfig.breakpoints,
    sitebar: '(min-width: 700px)',
    hpa: '(max-width: 699px)',
    mobile: '(max-width: 399px)',
  },
  components: {
    closeAd: {
      ...defaultCreativesConfig.components.closeAd,
      defaults: {
        ...defaultCreativesConfig.components.closeAd.defaults,
        centered: true,
      },
    },
    copyright: {
      ...defaultCreativesConfig.components.copyright,
    },
    countdown: {
      ...defaultCreativesConfig.components.countdown,
    },
    custom: {
      ...defaultCreativesConfig.components.custom,
    },
    footerLogo: {
      ...defaultCreativesConfig.components.footerLogo,
    },
    headerLogo: {
      ...defaultCreativesConfig.components.headerLogo,
    },
    image: {
      ...defaultCreativesConfig.components.image,
    },
    modal: {
      ...defaultCreativesConfig.components.modal,
    },
    pricePatch: {
      ...defaultCreativesConfig.components.pricePatch,
    },
    slider: {
      ...defaultCreativesConfig.components.slider,
    },
    socialFlyoutBar: {
      ...defaultCreativesConfig.components.socialFlyoutBar,
    },
    socialMediaBar: {
      ...defaultCreativesConfig.components.socialMediaBar,
    },
    socialmedia: {
      ...defaultCreativesConfig.components.socialmedia,
    },
    socialmediaFooter: {
      ...defaultCreativesConfig.components.socialmediaFooter,
    },
    stickyCTA: {
      ...defaultCreativesConfig.components.stickyCTA,
    },
    stickyImage: {
      ...defaultCreativesConfig.components.stickyImage,
    },
    stickyText: {
      ...defaultCreativesConfig.components.stickyText,
    },
    terms: {
      ...defaultCreativesConfig.components.terms,
    },
    text: {
      ...defaultCreativesConfig.components.text,
    },
    hover: {
      ...defaultCreativesConfig.components.hover,
      defaults: {
        ...defaultCreativesConfig.components.hover.defaults,
      },
    },
    viewLater: {
      ...defaultCreativesConfig.components.viewLater,
    },
    vastVideoXL: {
      ...defaultCreativesConfig.components.vastVideoXL,
    },
    imageMap: {
      ...defaultCreativesConfig.components.imageMap,
    },
    spotlights: {
      ...defaultCreativesConfig.components.spotlights,
    },
    spotlightsArea: {
      ...defaultCreativesConfig.components.spotlightsArea,
    },
    enhancedStore: {
      ...defaultCreativesConfig.components.enhancedStore,
    },
    productCard: {
      ...defaultCreativesConfig.components.productCard,
    },
    productCardProduct: {
      ...defaultCreativesConfig.components.productCardProduct,
    },
  },
};
